import React from 'react';
import Box from '../Box/Box';
import filterConditionalKeyValues from '../../utils/filterConditionalKeyValues';
import Icon from '../Icon/Icon'; // Import the Icon component

export type TLinkBase = {
  href?: string;
  onClick?: (e?: any) => void;
  kind?: 'block' | 'isolated' | 'paragraph' | 'standalone';
  target?: string;
  className?: string;
  rel?: string;
  iconLeft?: string;
  iconRight?: string;
} & React.HTMLAttributes<any>;

const LinkBase = ({ kind, href, onClick, iconLeft, iconRight, children, ...rest }: TLinkBase) => {
  const conditionalProps = filterConditionalKeyValues({
    modifiers: kind || 'isolated',
  });

  return (
    <Box
      {...rest}
      name="Link"
      as={href ? 'a' : 'button'}
      onClick={onClick}
      href={href}
      {...conditionalProps}
      role="link"
    >
      {iconLeft && <Icon name={iconLeft} color="text-link-default" />}
      {children}
      {iconRight && <Icon name={iconRight} color="text-link-default" />}
    </Box>
  );
};

export default LinkBase;
